import { Button, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IEntityContentField } from '../../lib/interfaces/Common';
import { FormField } from '../../lib/interfaces/Form';
import { IProduct } from '../../lib/interfaces/Product';
import { FIELD_TYPES } from '../Form/form.utils';
import ContentRenderer from '../Smart/Content/ContentRenderer';
import { PRODUCT_CONTENT_FIELDS } from './productOrderFormFieds';
import './ProductOrderSummary.scss';

type ProductOrderSummaryType = {
	product: IProduct;
	productName: string;
	orderFormValues: any;
	fields: FormField[];
	isActive: boolean;
	onPurchase: () => void;
};

const ProductOrderSummary: FC<ProductOrderSummaryType> = ({
	product,
	productName,
	orderFormValues,
	fields,
	isActive,
	onPurchase,
}) => {
	const { t, i18n } = useTranslation();
	const currentLanguage: string = i18n.language;
	const contentFields: IEntityContentField[] = product.content[currentLanguage];
	const noPurchaseVersion = true;

	const orderPageContent = contentFields.find(
		(field) =>
			field.name === `${PRODUCT_CONTENT_FIELDS.ORDER_PAGE}_${currentLanguage}`,
	);

	const getFormattedValue = (value: any, field: any) => {
		if (value) {
			if (field.type === FIELD_TYPES.SELECT) {
				// TODO find in fields -> select -> option -> label and translate
				return value ? t(value) : '';
			}
			if (field.type === FIELD_TYPES.FILE) {
				return value ? t('fileAttached') : t('nA');
			}
		}
		return t('nA');
	};

	return (
		<div className="ProductOrderSummary">
			<div className="ProductOrderSummary__wrapper">
				<div className="ProductOrderSummary__column">
					<Typography variant="h5">{productName}</Typography>
					<Typography variant="h5">${product.price}</Typography>
					<Typography variant="body1" component="div">
						{orderPageContent?.content && (
							<ContentRenderer html={orderPageContent.content} />
						)}
					</Typography>
				</div>
				<div className="ProductOrderSummary__column">
					{fields.map((field) => {
						const value = orderFormValues[field.name];
						const formattedValue =
							value &&
							typeof value === 'string' &&
							(field.type === FIELD_TYPES.TEXT || field.type === FIELD_TYPES.TEXTAREA)
								? value
								: getFormattedValue(value, field);

						return (
							<div key={field.name}>
								<Typography variant="body1" component="div">
									<strong>{t(field.label)}</strong>
								</Typography>
								<Typography variant="body1">{formattedValue}</Typography>
							</div>
						);
					})}
				</div>
			</div>

			{!noPurchaseVersion && (
				<Button
					variant="contained"
					color="primary"
					disableElevation
					onClick={onPurchase}
					disabled={!isActive}
				>
					{t('purchase')}
				</Button>
			)}
		</div>
	);
};

export default ProductOrderSummary;
